module.exports = __webpack_public_path__ + "img/notifications.7f2539ce.svg";